import React from 'react';

export default () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="11" fill="#F0F2F5" />
    <g clip-path="url(#clip0_1068_27731)">
      <path
        d="M12 4C7.58214 4 4 7.58214 4 12C4 16.4179 7.58214 20 12 20C16.4179 20 20 16.4179 20 12C20 7.58214 16.4179 4 12 4ZM12 18.6429C8.33214 18.6429 5.35714 15.6679 5.35714 12C5.35714 8.33214 8.33214 5.35714 12 5.35714C15.6679 5.35714 18.6429 8.33214 18.6429 12C18.6429 15.6679 15.6679 18.6429 12 18.6429Z"
        fill="#141414"
      />
      <path
        d="M15.1198 14.259L12.5734 12.418V7.99833C12.5734 7.91975 12.5091 7.85547 12.4305 7.85547H11.5716C11.493 7.85547 11.4287 7.91975 11.4287 7.99833V12.9162C11.4287 12.9626 11.4501 13.0055 11.4876 13.0323L14.4412 15.1858C14.5055 15.2323 14.5948 15.218 14.6412 15.1555L15.1519 14.459C15.1984 14.393 15.1841 14.3037 15.1198 14.259Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_1068_27731">
        <rect width="16" height="16" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);
